import { faFileLines as farFileLines } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import {
	faCheckCircle as fadCheckCircle,
	faCircleChevronRight as fadCircleChevronRight,
} from "@awesome.me/kit-3777c2145e/icons/duotone/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { Config } from "@/app/config";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { GoogleAnalytics4 } from "@/shared/lib/google-analytics-4";
import { ButtonLegacy } from "@/shared/ui";

type StepFields = {};

interface Props extends AbstractStepProps {
	leadId: number;
	email: string;
	variant: "erste" | undefined;
}

export class SuccessLead extends AbstractStep<StepFields, Props> {
	protected renderContent(): ReactNode {
		const { leadId, email } = this.props;

		const href = Config.getBankmonitorUrl("/babavaro-hitel/adatbekero/", {
			li: leadId,
			email: email,
			event_subType: "small_calculator",
		});

		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">Köszönjük, hogy leadtad érdeklődésed!</Card.Title>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<div className="my-auto py-2 text-center">
						<FontAwesomeIcon icon={fadCheckCircle} className="mb-2" size="4x" />
						<br />
						Az eredményeket elküldtük az email címedre.
					</div>
					<div className="text-center font-weight-bold pb-3">
						Ha nem érkezik meg perceken belül, ellenőrizd leveleződ „spam/levélszemét” mappáját is!
					</div>
				</Card.Body>
				<Card.Body className="bg-success-500 d-flex flex-column pb-1">
					<div className="text-center text-uppercase display-6 font-weight-bold mb-0 py-4">
						Szeretnéd felgyorsítani az igénylésed?
					</div>
					<div className="text-center font-weight-bold mb-3">Töltsd ki az adatbekérőt!</div>
					<div className="text-center">
						<FontAwesomeIcon icon={fadCircleChevronRight} size="4x" rotation={90} />
					</div>
				</Card.Body>
				<Card.Footer className="bg-success-500 text-center">
					<ButtonLegacy
						rel="nofollow"
						href={href}
						variant="gold"
						onClick={this.onDataFormButtonClick}
						target="_blank"
						className="text-uppercase"
						block
						icon={<FontAwesomeIcon icon={farFileLines} />}
					>
						Adatbekérő
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	@autobind
	private onDataFormButtonClick(): void {
		const { email } = this.props;

		this.sendEvent("BM_fastTrack", {
			buttonId: GoogleAnalytics4.generateId("bi"),
			email,
			user_data: {
				email_address: email,
			},
			productName: "Erste Online Babaváró",
		});
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}

	protected getComponentName(): string {
		return "SuccessLead";
	}
}
